import styled from 'styled-components';

export const UnregisteredStyle = styled.div`
  .card-subsection-form {
    .radio-option {
      margin-right: 10px;
    }
  }

  .row {
    .radio-option {
      margin-right: 10px;
    }
  }
  .MuiFormControl-root {
    .MuiFilledInput-root {
      border: 1px solid #bfc4ca;
      transition: border 0.3s;

      &.Mui-focused {
        border: 1px solid #0094d9;
      }
    }
  }

  .search-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;

    .MuiButtonBase-root {
      width: auto;
    }

    .MuiAutocomplete-root {
      flex: 1;
      /* margin-right: 12px; */

      .MuiFormControl-root {
        margin-top: 0;
        margin-bottom: 0;

        .MuiInputBase-root {
          border: none;
          background-color: #fafafb;
        }
      }
    }
  }

  .radio-container {
    background-color: transparent;
    padding: 0;
  }

  .error-block {
    display: block;
    width: 100%;
  }
  .register-content {
    margin-top: 20px;
  }
`;
